document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".video-gallery__slider");

  if (!slider) return;

  const originalCards = Array.from(
    slider.querySelectorAll(".video-card")
  );

  if (!originalCards.length) return;

  /* =====================================================
     INFINITE AUTO SCROLL
     ===================================================== */

  let speed = 0.6;
  let normalSpeed = 0.6;
  let scrollPosition = slider.scrollLeft;
  let loopWidth = 0;
  let animationFrameId = null;
  let isPaused = false;

  /*
   * Add enough copies so the content always remains wider
   * than the screen, including on large desktop displays.
   */
  function createCopies() {
    const firstCopyMarker = document.createElement("span");

    firstCopyMarker.className = "video-gallery__loop-marker";
    firstCopyMarker.setAttribute("aria-hidden", "true");

    slider.appendChild(firstCopyMarker);

    originalCards.forEach((card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      slider.appendChild(clone);
    });

    /*
     * Add extra sets when one duplicate is not enough to
     * cover the visible width.
     */
    while (slider.scrollWidth < slider.clientWidth * 3) {
      originalCards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        slider.appendChild(clone);
      });
    }

    loopWidth = firstCopyMarker.offsetLeft;
    firstCopyMarker.remove();
  }

  createCopies();

  function autoScroll() {
    if (!isPaused && loopWidth > 0) {
      scrollPosition += speed;

      /*
       * Subtract the original content width instead of
       * resetting abruptly to zero.
       */
      if (scrollPosition >= loopWidth) {
        scrollPosition -= loopWidth;
      }

      slider.scrollLeft = scrollPosition;
    }

    animationFrameId = requestAnimationFrame(autoScroll);
  }

  autoScroll();

  /* Pause while the customer is interacting */
  slider.addEventListener("mouseenter", function () {
    isPaused = true;
  });

  slider.addEventListener("mouseleave", function () {
    scrollPosition = slider.scrollLeft;
    isPaused = false;
  });

  slider.addEventListener(
    "touchstart",
    function () {
      isPaused = true;
    },
    { passive: true }
  );

  slider.addEventListener(
    "touchend",
    function () {
      scrollPosition = slider.scrollLeft;

      window.setTimeout(function () {
        isPaused = false;
      }, 500);
    },
    { passive: true }
  );

  slider.addEventListener(
    "scroll",
    function () {
      if (isPaused) {
        scrollPosition = slider.scrollLeft;
      }
    },
    { passive: true }
  );

  /*
   * Recalculate when the browser size changes.
   */
  window.addEventListener("resize", function () {
    scrollPosition = slider.scrollLeft;
  });

  /*
   * Keep animation stable when the user changes tabs.
   */
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      scrollPosition = slider.scrollLeft;
    }
  });

  /* =====================================================
     VIDEO POPUP
     ===================================================== */

  const popup = document.querySelector(".video-popup");
  const popupVideo = document.getElementById("popupVideo");
  const closeBtn = document.querySelector(".video-popup__close");

  if (!popup || !popupVideo || !closeBtn) return;

  document.addEventListener("click", function (event) {
    const card = event.target.closest(".video-card");

    if (!card || !card.dataset.video) return;

    isPaused = true;

    popup.classList.add("active");
    popupVideo.src = card.dataset.video;
    popupVideo.load();

    const playPromise = popupVideo.play();

    if (playPromise !== undefined) {
      playPromise.catch(function () {
        /* Browser may block autoplay until another interaction. */
      });
    }

    document.body.style.overflow = "hidden";
  });

  function closeVideo() {
    popup.classList.remove("active");

    popupVideo.pause();
    popupVideo.currentTime = 0;
    popupVideo.removeAttribute("src");
    popupVideo.load();

    document.body.style.overflow = "";

    scrollPosition = slider.scrollLeft;
    isPaused = false;
  }

  closeBtn.addEventListener("click", closeVideo);

  popup.addEventListener("click", function (event) {
    if (event.target === popup) {
      closeVideo();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && popup.classList.contains("active")) {
      closeVideo();
    }
  });

  /*
   * Cleanup if Shopify reloads/removes the section.
   */
  document.addEventListener("shopify:section:unload", function () {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }
  });
});